module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-up-fill-a97fe783.svg";